"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkSupport = void 0;
const contentTypes = require("./content-types");
const registry_call_1 = require("./registry-call");
const options_1 = require("./options");
/**
 * Check whether the registry implements the OCI Distribution Specification.
 *
 * Performs a `GET` request to `/v2/` endpoint as per the OCI Distribution spec.
 * This is typically used to verify registry compatibility and connectivity.
 *
 * OCI Distribution Specification endpoint: `/v2/`
 *
 * @param registryBase - The base URL of the container registry (e.g., "registry.example.com")
 * @param username - Optional username for authentication
 * @param password - Optional password for authentication
 * @param options - Optional request configuration options
 * @param observer - Optional observer to record client events
 *
 * @returns HTTP response body indicating registry support status
 */
async function checkSupport(registryBase, username, password, options = {}, observer) {
    const cloned = (0, options_1.cloneOptions)(options);
    const result = await (0, registry_call_1.registryV2Call)(registryBase, "/", // full url path should be "/v2/" as per spec
    contentTypes.JSON, username, password, cloned, observer);
    // always return truthy object, even for ECR
    return result || {};
}
exports.checkSupport = checkSupport;
//# sourceMappingURL=check-support.js.map